webpackJsonp([229286049741028],{

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconsPage = function IconsPage() {
	  return _react2.default.createElement(
	    "main",
	    { className: "docs-masthead" },
	    _react2.default.createElement(
	      "h1",
	      { className: "sr-only" },
	      "Components Page"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid" },
	      _react2.default.createElement(
	        "h2",
	        { className: "docs-title" },
	        "Sizes"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "normal"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-lg" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "icon-lg"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-xl" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "icon-xl"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-2x" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "icon-2x"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-3x" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "icon-3x"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-4x" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "icon-4x"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-2 text-center" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-lg icon-5x" }),
	          " ",
	          _react2.default.createElement(
	            "h5",
	            { className: "subheader" },
	            "icon-5x"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "h2",
	        { className: "docs-title" },
	        "Icons"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe800" },
	          _react2.default.createElement("i", { className: "icon icon-home icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-home"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe800"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe801" },
	          _react2.default.createElement("i", { className: "icon icon-terminal icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-terminal"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe801"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe802" },
	          _react2.default.createElement("i", { className: "icon icon-down-dir icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-down-dir"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe802"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe803" },
	          _react2.default.createElement("i", { className: "icon icon-bell-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bell-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe803"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe804" },
	          _react2.default.createElement("i", { className: "icon icon-up-dir icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-up-dir"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe804"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe805" },
	          _react2.default.createElement("i", { className: "icon icon-left-dir icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-left-dir"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe805"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe806" },
	          _react2.default.createElement("i", { className: "icon icon-right-dir icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-right-dir"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe806"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe807" },
	          _react2.default.createElement("i", { className: "icon icon-info-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-info-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe807"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe809" },
	          _react2.default.createElement("i", { className: "icon icon-key icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-key"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe809"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe80a" },
	          _react2.default.createElement("i", { className: "icon icon-ok-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-ok-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe80a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe80b" },
	          _react2.default.createElement("i", { className: "icon icon-link-ext icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-link-ext"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe80b"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe80c" },
	          _react2.default.createElement("i", { className: "icon icon-cc-visa icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cc-visa"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe80c"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe80d" },
	          _react2.default.createElement("i", { className: "icon icon-cc-mastercard icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cc-mastercard"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe80d"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe80e" },
	          _react2.default.createElement("i", { className: "icon icon-cc-discover icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cc-discover"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe80e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe80f" },
	          _react2.default.createElement("i", { className: "icon icon-cc-amex icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cc-amex"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe80f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe810" },
	          _react2.default.createElement("i", { className: "icon icon-cc-paypal icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cc-paypal"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe810"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe811" },
	          _react2.default.createElement("i", { className: "icon icon-cc-stripe icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cc-stripe"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe811"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe812" },
	          _react2.default.createElement("i", { className: "icon icon-location icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-location"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe812"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe813" },
	          _react2.default.createElement("i", { className: "icon icon-credit-card icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-credit-card"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe813"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe814" },
	          _react2.default.createElement("i", { className: "icon icon-user-md icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-user-md"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe814"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe815" },
	          _react2.default.createElement("i", { className: "icon icon-stethoscope icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-stethoscope"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe815"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe816" },
	          _react2.default.createElement("i", { className: "icon icon-ambulance icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-ambulance"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe816"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe817" },
	          _react2.default.createElement("i", { className: "icon icon-medkit icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-medkit"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe817"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe818" },
	          _react2.default.createElement("i", { className: "icon icon-h-sigh icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-h-sigh"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe818"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe819" },
	          _react2.default.createElement("i", { className: "icon icon-hospital icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-hospital"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe819"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe81a" },
	          _react2.default.createElement("i", { className: "icon icon-building icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-building"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe81a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe81b" },
	          _react2.default.createElement("i", { className: "icon icon-filter icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-filter"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe81b"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe81c" },
	          _react2.default.createElement("i", { className: "icon icon-help-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-help-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe81c"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe81d" },
	          _react2.default.createElement("i", { className: "icon icon-heart icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-heart"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe81d"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe81e" },
	          _react2.default.createElement("i", { className: "icon icon-file-image icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-image"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe81e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe81f" },
	          _react2.default.createElement("i", { className: "icon icon-file-powerpoint icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-powerpoint"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe81f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe820" },
	          _react2.default.createElement("i", { className: "icon icon-file-excel icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-excel"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe820"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe821" },
	          _react2.default.createElement("i", { className: "icon icon-file-word icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-word"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe821"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe822" },
	          _react2.default.createElement("i", { className: "icon icon-file-pdf icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-pdf"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe822"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe823" },
	          _react2.default.createElement("i", { className: "icon icon-file-archive icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-archive"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe823"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe824" },
	          _react2.default.createElement("i", { className: "icon icon-file-code icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-code"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe824"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe825" },
	          _react2.default.createElement("i", { className: "icon icon-doc-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-doc-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe825"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe826" },
	          _react2.default.createElement("i", { className: "icon icon-doc-text-inv icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-doc-text-inv"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe826"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe827" },
	          _react2.default.createElement("i", { className: "icon icon-doc-inv icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-doc-inv"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe827"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe828" },
	          _react2.default.createElement("i", { className: "icon icon-trash-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-trash-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe828"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe829" },
	          _react2.default.createElement("i", { className: "icon icon-newspaper icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-newspaper"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe829"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe82a" },
	          _react2.default.createElement("i", { className: "icon icon-graduation-cap icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-graduation-cap"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe82a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe82b" },
	          _react2.default.createElement("i", { className: "icon icon-clipboard icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-clipboard"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe82b"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe82c" },
	          _react2.default.createElement("i", { className: "icon icon-css3 icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-css3"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe82c"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe82d" },
	          _react2.default.createElement("i", { className: "icon icon-chat icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-chat"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe82d"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe82e" },
	          _react2.default.createElement("i", { className: "icon icon-chat-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-chat-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe82e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe82f" },
	          _react2.default.createElement("i", { className: "icon icon-edit icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-edit"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe82f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe830" },
	          _react2.default.createElement("i", { className: "icon icon-attention-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-attention-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe830"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe831" },
	          _react2.default.createElement("i", { className: "icon icon-cancel-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cancel-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe831"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe832" },
	          _react2.default.createElement("i", { className: "icon icon-minus-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-minus-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe832"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe833" },
	          _react2.default.createElement("i", { className: "icon icon-plus-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-plus-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe833"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe834" },
	          _react2.default.createElement("i", { className: "icon icon-chart-line icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-chart-line"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe834"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe836" },
	          _react2.default.createElement("i", { className: "icon icon-credentialing icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-credentialing"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe836"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe837" },
	          _react2.default.createElement("i", { className: "icon icon-medicine icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-medicine"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe837"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe83c" },
	          _react2.default.createElement("i", { className: "icon icon-mail icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-mail"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe83c"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe83d" },
	          _react2.default.createElement("i", { className: "icon icon-mail-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-mail-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe83d"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe83e" },
	          _react2.default.createElement("i", { className: "icon icon-heart-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-heart-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe83e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe83f" },
	          _react2.default.createElement("i", { className: "icon icon-star-half icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-star-half"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe83f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe840" },
	          _react2.default.createElement("i", { className: "icon icon-star-half-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-star-half-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe840"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe841" },
	          _react2.default.createElement("i", { className: "icon icon-user icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-user"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe841"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe842" },
	          _react2.default.createElement("i", { className: "icon icon-users icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-users"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe842"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe843" },
	          _react2.default.createElement("i", { className: "icon icon-picture icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-picture"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe843"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe844" },
	          _react2.default.createElement("i", { className: "icon icon-th-large icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-th-large"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe844"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe845" },
	          _react2.default.createElement("i", { className: "icon icon-print icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-print"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe845"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe846" },
	          _react2.default.createElement("i", { className: "icon icon-code icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-code"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe846"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe847" },
	          _react2.default.createElement("i", { className: "icon icon-download-cloud icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-download-cloud"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe847"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe848" },
	          _react2.default.createElement("i", { className: "icon icon-star-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-star-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe848"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe849" },
	          _react2.default.createElement("i", { className: "icon icon-star icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-star"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe849"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe84a" },
	          _react2.default.createElement("i", { className: "icon icon-cog icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cog"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe84a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe84b" },
	          _react2.default.createElement("i", { className: "icon icon-angle-down icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-down"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe84b"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe84c" },
	          _react2.default.createElement("i", { className: "icon icon-angle-up icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-up"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe84c"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe84d" },
	          _react2.default.createElement("i", { className: "icon icon-angle-right icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-right"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe84d"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe84e" },
	          _react2.default.createElement("i", { className: "icon icon-angle-left icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-left"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe84e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe84f" },
	          _react2.default.createElement("i", { className: "icon icon-search icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-search"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe84f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe850" },
	          _react2.default.createElement("i", { className: "icon icon-copyright icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-copyright"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe850"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe851" },
	          _react2.default.createElement("i", { className: "icon icon-calendar icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-calendar"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe851"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe852" },
	          _react2.default.createElement("i", { className: "icon icon-circle-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-circle-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe852"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe853" },
	          _react2.default.createElement("i", { className: "icon icon-circle icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-circle"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe853"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe854" },
	          _react2.default.createElement("i", { className: "icon icon-right-circled icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-right-circled"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe854"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe855" },
	          _react2.default.createElement("i", { className: "icon icon-left-circled icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-left-circled"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe855"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe856" },
	          _react2.default.createElement("i", { className: "icon icon-up-circled icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-up-circled"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe856"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe857" },
	          _react2.default.createElement("i", { className: "icon icon-down-circled icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-down-circled"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe857"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe858" },
	          _react2.default.createElement("i", { className: "icon icon-down-small icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-down-small"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe858"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe859" },
	          _react2.default.createElement("i", { className: "icon icon-left-small icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-left-small"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe859"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe85a" },
	          _react2.default.createElement("i", { className: "icon icon-right-small icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-right-small"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe85a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe85b" },
	          _react2.default.createElement("i", { className: "icon icon-up-small icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-up-small"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe85b"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe85c" },
	          _react2.default.createElement("i", { className: "icon icon-ok icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-ok"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe85c"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe85d" },
	          _react2.default.createElement("i", { className: "icon icon-check icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-check"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe85d"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe85e" },
	          _react2.default.createElement("i", { className: "icon icon-check-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-check-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe85e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe85f" },
	          _react2.default.createElement("i", { className: "icon icon-th icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-th"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe85f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe860" },
	          _react2.default.createElement("i", { className: "icon icon-th-list icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-th-list"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe860"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe861" },
	          _react2.default.createElement("i", { className: "icon icon-menu icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-menu"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe861"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe862" },
	          _react2.default.createElement("i", { className: "icon icon-cancel icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-cancel"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe862"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe863" },
	          _react2.default.createElement("i", { className: "icon icon-clock icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-clock"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe863"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe864" },
	          _react2.default.createElement("i", { className: "icon icon-plus icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-plus"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe864"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe865" },
	          _react2.default.createElement("i", { className: "icon icon-thumbs-up-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-thumbs-up-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe865"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe866" },
	          _react2.default.createElement("i", { className: "icon icon-minus icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-minus"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe866"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe867" },
	          _react2.default.createElement("i", { className: "icon icon-thumbs-down-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-thumbs-down-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe867"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe868" },
	          _react2.default.createElement("i", { className: "icon icon-help icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-help"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe868"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe869" },
	          _react2.default.createElement("i", { className: "icon icon-info icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-info"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe869"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe86a" },
	          _react2.default.createElement("i", { className: "icon icon-link icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-link"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe86a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe86b" },
	          _react2.default.createElement("i", { className: "icon icon-unlink icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-unlink"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe86b"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe86c" },
	          _react2.default.createElement("i", { className: "icon icon-attach icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-attach"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe86c"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe86d" },
	          _react2.default.createElement("i", { className: "icon icon-lock icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-lock"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe86d"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe86e" },
	          _react2.default.createElement("i", { className: "icon icon-lock-open icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-lock-open"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe86e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe86f" },
	          _react2.default.createElement("i", { className: "icon icon-pin icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-pin"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe86f"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe872" },
	          _react2.default.createElement("i", { className: "icon icon-tag icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-tag"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe872"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe873" },
	          _react2.default.createElement("i", { className: "icon icon-tags icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-tags"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe873"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe874" },
	          _react2.default.createElement("i", { className: "icon icon-bookmark icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bookmark"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe874"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe875" },
	          _react2.default.createElement("i", { className: "icon icon-bookmark-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bookmark-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe875"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe876" },
	          _react2.default.createElement("i", { className: "icon icon-flag icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-flag"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe876"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe877" },
	          _react2.default.createElement("i", { className: "icon icon-flag-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-flag-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe877"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe878" },
	          _react2.default.createElement("i", { className: "icon icon-upload-cloud icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-upload-cloud"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe878"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe879" },
	          _react2.default.createElement("i", { className: "icon icon-reply icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-reply"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe879"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe87a" },
	          _react2.default.createElement("i", { className: "icon icon-reply-all icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-reply-all"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe87a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe87b" },
	          _react2.default.createElement("i", { className: "icon icon-forward icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-forward"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe87b"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe87c" },
	          _react2.default.createElement("i", { className: "icon icon-quote-left icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-quote-left"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe87c"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe87d" },
	          _react2.default.createElement("i", { className: "icon icon-quote-right icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-quote-right"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe87d"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe87e" },
	          _react2.default.createElement("i", { className: "icon icon-export icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-export"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe87e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe87f" },
	          _react2.default.createElement("i", { className: "icon icon-share icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-share"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe87f"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe880" },
	          _react2.default.createElement("i", { className: "icon icon-pencil icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-pencil"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe880"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe881" },
	          _react2.default.createElement("i", { className: "icon icon-comment icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-comment"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe881"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe882" },
	          _react2.default.createElement("i", { className: "icon icon-comment-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-comment-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe882"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe883" },
	          _react2.default.createElement("i", { className: "icon icon-bell icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bell"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe883"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe884" },
	          _react2.default.createElement("i", { className: "icon icon-bell-off icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bell-off"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe884"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe885" },
	          _react2.default.createElement("i", { className: "icon icon-bell-off-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bell-off-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe885"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe886" },
	          _react2.default.createElement("i", { className: "icon icon-attention-alt icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-attention-alt"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe886"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe887" },
	          _react2.default.createElement("i", { className: "icon icon-attention icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-attention"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe887"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe888" },
	          _react2.default.createElement("i", { className: "icon icon-doc icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-doc"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe888"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe889" },
	          _react2.default.createElement("i", { className: "icon icon-docs icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-docs"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe889"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe88a" },
	          _react2.default.createElement("i", { className: "icon icon-folder-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-folder-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe88a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe88b" },
	          _react2.default.createElement("i", { className: "icon icon-folder-open-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-folder-open-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe88b"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe88c" },
	          _react2.default.createElement("i", { className: "icon icon-box icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-box"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe88c"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe88d" },
	          _react2.default.createElement("i", { className: "icon icon-phone icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-phone"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe88d"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe88e" },
	          _react2.default.createElement("i", { className: "icon icon-fax icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-fax"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe88e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe88f" },
	          _react2.default.createElement("i", { className: "icon icon-basket icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-basket"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe88f"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe890" },
	          _react2.default.createElement("i", { className: "icon icon-angle-double-left icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-double-left"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe890"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe891" },
	          _react2.default.createElement("i", { className: "icon icon-angle-double-right icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-double-right"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe891"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe892" },
	          _react2.default.createElement("i", { className: "icon icon-angle-double-up icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-double-up"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe892"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe893" },
	          _react2.default.createElement("i", { className: "icon icon-angle-double-down icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-angle-double-down"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe893"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe894" },
	          _react2.default.createElement("i", { className: "icon icon-down-big icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-down-big"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe894"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe895" },
	          _react2.default.createElement("i", { className: "icon icon-left-big icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-left-big"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe895"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe896" },
	          _react2.default.createElement("i", { className: "icon icon-right-big icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-right-big"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe896"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe897" },
	          _react2.default.createElement("i", { className: "icon icon-up-big icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-up-big"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe897"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe898" },
	          _react2.default.createElement("i", { className: "icon icon-arrows-cw icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-arrows-cw"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe898"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe899" },
	          _react2.default.createElement("i", { className: "icon icon-history icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-history"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe899"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe89a" },
	          _react2.default.createElement("i", { className: "icon icon-award icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-award"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe89a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe89f" },
	          _react2.default.createElement("i", { className: "icon icon-inbox icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-inbox"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe89f"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a0" },
	          _react2.default.createElement("i", { className: "icon icon-briefcase icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-briefcase"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a0"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a1" },
	          _react2.default.createElement("i", { className: "icon icon-suitcase icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-suitcase"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a1"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a2" },
	          _react2.default.createElement("i", { className: "icon icon-ellipsis icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-ellipsis"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a2"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a3" },
	          _react2.default.createElement("i", { className: "icon icon-ellipsis-vert icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-ellipsis-vert"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a3"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a4" },
	          _react2.default.createElement("i", { className: "icon icon-check-empty icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-check-empty"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a4"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a5" },
	          _react2.default.createElement("i", { className: "icon icon-circle-thin icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-circle-thin"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a5"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a6" },
	          _react2.default.createElement("i", { className: "icon icon-dot-circled icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-dot-circled"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a6"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a7" },
	          _react2.default.createElement("i", { className: "icon icon-asterisk icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-asterisk"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a7"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a8" },
	          _react2.default.createElement("i", { className: "icon icon-chart-bar icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-chart-bar"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a8"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8a9" },
	          _react2.default.createElement("i", { className: "icon icon-chart-area icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-chart-area"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8a9"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8aa" },
	          _react2.default.createElement("i", { className: "icon icon-chart-pie icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-chart-pie"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8aa"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8ab" },
	          _react2.default.createElement("i", { className: "icon icon-fork icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-fork"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8ab"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8ac" },
	          _react2.default.createElement("i", { className: "icon icon-certificate icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-certificate"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8ac"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8ad" },
	          _react2.default.createElement("i", { className: "icon icon-tasks icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-tasks"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8ad"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8ae" },
	          _react2.default.createElement("i", { className: "icon icon-beaker icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-beaker"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8ae"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8af" },
	          _react2.default.createElement("i", { className: "icon icon-money icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-money"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8af"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b0" },
	          _react2.default.createElement("i", { className: "icon icon-sort icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-sort"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b0"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b1" },
	          _react2.default.createElement("i", { className: "icon icon-sort-down icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-sort-down"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b1"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b2" },
	          _react2.default.createElement("i", { className: "icon icon-sort-up icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-sort-up"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b2"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b3" },
	          _react2.default.createElement("i", { className: "icon icon-sort-alt-up icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-sort-alt-up"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b3"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b4" },
	          _react2.default.createElement("i", { className: "icon icon-sort-alt-down icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-sort-alt-down"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b4"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b5" },
	          _react2.default.createElement("i", { className: "icon icon-hammer icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-hammer"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b5"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b6" },
	          _react2.default.createElement("i", { className: "icon icon-gauge icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-gauge"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b6"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b7" },
	          _react2.default.createElement("i", { className: "icon icon-sitemap icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-sitemap"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b7"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b8" },
	          _react2.default.createElement("i", { className: "icon icon-extinguisher icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-extinguisher"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b8"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8b9" },
	          _react2.default.createElement("i", { className: "icon icon-database icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-database"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8b9"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8bb" },
	          _react2.default.createElement("i", { className: "icon icon-android icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-android"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8bb"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8cf" },
	          _react2.default.createElement("i", { className: "icon icon-paste icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-paste"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8cf"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8d0" },
	          _react2.default.createElement("i", { className: "icon icon-draw-chart icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-draw-chart"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8d0"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8d1" },
	          _react2.default.createElement("i", { className: "icon icon-user-plus icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-user-plus"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8d1"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8d3" },
	          _react2.default.createElement("i", { className: "icon icon-play icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-play"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8d2"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe8d3" },
	          _react2.default.createElement("i", { className: "icon icon-pause icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-pause"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe8d3"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf118" },
	          _react2.default.createElement("i", { className: "icon icon-smile icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-smile"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf118"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf119" },
	          _react2.default.createElement("i", { className: "icon icon-frown icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-frown"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf119"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf11a" },
	          _react2.default.createElement("i", { className: "icon icon-meh icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-meh"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf11a"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf1c7" },
	          _react2.default.createElement("i", { className: "icon icon-file-audio icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-audio"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf1c7"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf1c8" },
	          _react2.default.createElement("i", { className: "icon icon-file-video icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-file-video"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf1c8"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf21e" },
	          _react2.default.createElement("i", { className: "icon icon-heartbeat icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-heartbeat"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf21e"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf236" },
	          _react2.default.createElement("i", { className: "icon icon-bed icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-bed"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf236"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xf108" },
	          _react2.default.createElement("i", { className: "icon icon-desktop icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-desktop"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xf108"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row mb-4" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe808" },
	          _react2.default.createElement("i", { className: "icon icon-eye icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-eye"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe808"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm text-center", title: "Code: 0xe835" },
	          _react2.default.createElement("i", { className: "icon icon-eye-off icon-2x" }),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "icon-eye-off"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "d-block text-center" },
	            "0xe835"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IconsPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-icons-js-f3d11a4edded173ca747.js